import React, { createContext, useContext, useEffect, useState } from 'react'
import { Bridge } from 'src/utils/bridge'

export namespace ToastSpace {
  export interface ToastData {
    when?: boolean
    contents?: string
  }

  export interface ToastContextValue {
    isOpen: boolean
    openToast: (toastData: ToastData) => unknown
    closeToast: () => unknown
    toastData: ToastData
  }
}

const toastInitialValue: ToastSpace.ToastData = {
  when: true,
  contents: '',
}

const contextInitialValue = {
  isOpen: false,
  openToast: () => {},
  closeToast: () => {},
  toastData: toastInitialValue,
}

const ToastContext = createContext<ToastSpace.ToastContextValue>(contextInitialValue)

export const ToastContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [toastData, setToastData] = useState<ToastSpace.ToastData>(toastInitialValue)

  const openToast = (ToastData: ToastSpace.ToastData) => {
    Bridge.handleReqShowToast(ToastData.contents as string, () => {
      setIsOpen(true)
      setToastData({ ...ToastData, when: !ToastData.when ? true : ToastData.when })
    })
  }

  const closeToast = () => {
    setIsOpen(false)
    setToastData(toastInitialValue)
  }

  useEffect(() => {
    let timer = setTimeout(() => {
      closeToast()
    }, 3000)

    return () => {
      clearTimeout(timer)
    }
  }, [isOpen])

  return (
    <ToastContext.Provider value={{ isOpen, openToast, closeToast, toastData }}>
      {children}
    </ToastContext.Provider>
  )
}

export function useToast() {
  return useContext(ToastContext)
}
